

























































































































































import {
  computed,
  defineComponent,
  PropType,
  reactive,
  toRefs,
  getCurrentInstance
} from "@vue/composition-api";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuTitle from "@/components/Atoms/FloatingMenuItems/FloatingMenuTitle/index.vue";
import FloatingMenuButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuButton/index.vue";
import FloatingNotificationButton from "@/components/Atoms/FloatingMenuItems/FloatingNotificationButton/index.vue";
import FloatingFAQButton from "@/components/Atoms/FloatingMenuItems/FloatingFAQButton/index.vue";
import FloatingMenuFooter from "@/components/Atoms/FloatingMenuItems/FloatingMenuFooter/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import OccPanel from "@/components/Atoms/OccPanel/index.vue";
import OccIcon from "@/components/Atoms/OccIcon/index.vue";
import { faqs, zendeskHelCenterUrl } from "@/constants/zendesk";
import { ApiResponse } from "@/api/types";
import { sendGaEvent } from "@/helpers/ga-helper";
import { PRIVACY_POLICY } from "@/constants/external-links";
import { useStore } from "@/store";
import { useRouter } from "@/router";
import {
  fetchAndStoreContract,
  hasScoutAgentContract
} from "@/helpers/contract-helper";
import { MenuType } from "@/store/domains/user/types";
import { saveMenuTypeToLocalStorage } from "@/helpers/menu-type-helper";
// import { useRoute, useRouter } from "@/router"; // TODO: vue-router4移行時に書き換える
interface Data {
  isHelpFloatingMenuVisible: boolean;
  isNotificationFloatingMenuVisible: boolean;
  isSettingFloatingMenuVisible: boolean;
  loadingGetPlans: boolean;
}
export type MenuItem = {
  value: string;
  label: string;
};
export default defineComponent({
  components: {
    Heading,
    FloatingMenu,
    FloatingMenuTitle,
    FloatingMenuButton,
    FloatingNotificationButton,
    FloatingFAQButton,
    FloatingMenuFooter,
    OccPanel,
    OccIcon
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    notifications: {
      type: Array as PropType<ApiResponse.Notifications>,
      required: true
    },
    isHeaderNotificationBadgeVisible: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    const store = useStore();
    // const route = useRoute(); // TODO: vue-router4移行時に書き換える
    const router = useRouter();
    const state = reactive<Data>({
      isNotificationFloatingMenuVisible: false,
      isHelpFloatingMenuVisible: false,
      isSettingFloatingMenuVisible: false,
      loadingGetPlans: false
    });

    const partnerUser = computed<ApiResponse.PartnerUser | undefined>(
      () => store.state.domains.user.partnerUser
    );

    const floatingAccountMenuItems = computed(() => {
      const items = [
        {
          value: "termsOfUseForJob",
          label: "利用規約（求人掲載）"
        },
        {
          value: "termsOfUseForPlan",
          label: "利用規約（採用計画）"
        },
        {
          value: "termsOfUseForScout",
          label: "利用規約（スカウト）"
        },
        {
          value: "termsOfOutsourcing",
          label: "利用規約（採用代行）"
        },
        {
          value: "privacyPolicy",
          label: "プライバシーポリシー"
        },
        {
          value: "externalDataProcessors",
          label: "利用者情報の外部送信について"
        },
        props.isLoggedIn && {
          value: "signOut",
          label: "ログアウト"
        }
      ].filter((item): item is MenuItem => !!item);

      return items;
    });

    const filteredFaqs = computed(() => {
      // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
      // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
      // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
      const routeName = instance?.proxy.$route.name; // TODO: vue-router4移行時に書き換える
      if (!routeName) return [];

      const filteredFaqs = faqs.filter(faq =>
        faq.targetRouteNames.includes(routeName)
      );
      const defaultFaqs = faqs.filter(faq => !faq.targetRouteNames.length);
      return filteredFaqs.length ? filteredFaqs : defaultFaqs;
    });

    const handleClickNotificationButton = () => {
      emit("clickNotificationButton");
      toggleNotificationFloatingMenu();
    };
    const toggleNotificationFloatingMenu = () => {
      state.isNotificationFloatingMenuVisible = !state.isNotificationFloatingMenuVisible;
    };
    const handleClickNotificationList = () => {
      router.push({ name: "Notifications" }).catch(err => err); // NOTE: 重複遷移のエラーもみ消し
      toggleNotificationFloatingMenu();
    };

    const handleClickNotificationMenu = (notificationId: number) => {
      toggleNotificationFloatingMenu();
      const targetNotification = props.notifications.find(
        notification => notification.id === notificationId
      );
      if (targetNotification!.url) {
        // NOTE: 直接対象ページに遷移する時だけ、既読にする。
        emit("readNotification", notificationId);
        // NOTE: root.$routerでの遷移の場合コンテンツが切り替わらないためhrefで遷移させる
        location.href = `${location.origin}${targetNotification!.url}`;
      } else {
        router.push({ name: "Notifications" }).catch(err => err); // NOTE: 重複遷移のエラーもみ消し
      }
    };

    const toggleHelpFloatingMenu = () => {
      state.isHelpFloatingMenuVisible = !state.isHelpFloatingMenuVisible;
      state.isHelpFloatingMenuVisible;
    };

    const handleClickHelpMenu = (helpId: number) => {
      toggleHelpFloatingMenu();
      const targetFAQ = filteredFaqs.value.find(faq => faq.id === helpId);
      emit("clickZendeskUrl", targetFAQ!.url);
    };

    const handleClickHelpCenter = () => {
      toggleHelpFloatingMenu();
      emit("clickZendeskUrl", zendeskHelCenterUrl);
    };

    const toggleSettingFloatingMenu = () => {
      state.isSettingFloatingMenuVisible = !state.isSettingFloatingMenuVisible;
      state.isSettingFloatingMenuVisible;
    };

    const handleClickSettingMenu = (value: string) => {
      toggleSettingFloatingMenu();
      // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
      // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
      // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
      const currentRouterName = instance?.proxy.$root.$route.name ?? ""; // TODO: vue-router4移行時に書き換える
      switch (value) {
        case "termsOfUseForJob": {
          if (currentRouterName === "TermsOfUseForJob") return;

          const routerResolved = router.resolve({
            name: "TermsOfUseForJob"
          });
          window.open(routerResolved.href, "_blank", "noopener");
          return;
        }
        case "termsOfUseForPlan": {
          if (currentRouterName === "TermsOfUseForPlan") return;

          const routerResolved = router.resolve({
            name: "TermsOfUseForPlan"
          });
          window.open(routerResolved.href, "_blank", "noopener");
          return;
        }
        case "termsOfUseForScout": {
          if (currentRouterName === "TermsOfUseForScout") return;

          const routerResolved = router.resolve({
            name: "TermsOfUseForScout"
          });
          window.open(routerResolved.href, "_blank", "noopener");
          return;
        }
        case "termsOfOutsourcing": {
          if (currentRouterName === "TermsOfOutsourcing") return;

          const routerResolved = router.resolve({
            name: "TermsOfOutsourcing"
          });
          window.open(routerResolved.href, "_blank", "noopener");
          return;
        }
        case "externalDataProcessors": {
          if (currentRouterName === "ExternalDataProcessors") return;

          const routerResolved = router.resolve({
            name: "ExternalDataProcessors"
          });
          window.open(routerResolved.href, "_blank", "noopener");
          return;
        }
        case "privacyPolicy": {
          window.open(PRIVACY_POLICY, "_blank", "noopener");
          return;
        }
        case "signOut":
          emit("clickSignOut");
          break;
      }
    };
    const handleClickLogo = () => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: "ヘッダー_ロゴ"
        });
      }
      router.push({ name: "Home" }).catch(err => err); // NOTE: 重複遷移のエラーもみ消し
    };

    const handleClickClip = () => {
      router.push({ name: "Clips" }).catch(err => err);
    };

    const isScoutAgent = computed<boolean>(() => {
      if (!props.isLoggedIn || !partnerUser.value) {
        return false;
      }

      // エージェント契約を持つパートナーのみ切り替えスイッチを表示する
      // エージェントプランの契約が期限切れの場合でも画面の閲覧はさせたいため、期限切れの契約も含めて判定する
      const availableContracts =
        store.state.domains.user.availableContracts ?? [];
      const expiredContracts = store.state.domains.user.expiredContracts ?? [];
      const isScoutAgent = hasScoutAgentContract(
        availableContracts.concat(expiredContracts)
      );

      return isScoutAgent;
    });

    const agentSwitchText = computed<string>(() => {
      if (store.getters["domains/user/isScoutAgentMenuActive"]) {
        return "人事画面へ";
      }

      return "エージェント画面へ";
    });

    const changeMenuType = async () => {
      if (store.getters["domains/user/isScoutAgentMenuActive"]) {
        store.commit("domains/user/changeMenuType", MenuType.MENU_DEFAULT);
        saveMenuTypeToLocalStorage(MenuType.MENU_DEFAULT);
        await fetchAndStoreContract();
        router.push({ name: "Home" }).catch(err => err); // NOTE: 重複遷移のエラーもみ消し
        return;
      }

      store.commit("domains/user/changeMenuType", MenuType.MENU_SCOUT_AGENT);
      saveMenuTypeToLocalStorage(MenuType.MENU_SCOUT_AGENT);
      await fetchAndStoreContract();
      // 既に候補者一覧にいる場合を考慮してリロードフラグを設定する
      router
        .push({ name: "ScoutCandidates", query: { reload: "true" } })
        .catch(err => err); // NOTE: 重複遷移のエラーもみ消し
    };

    return {
      ...toRefs(state),
      partnerUser,
      floatingAccountMenuItems,
      filteredFaqs,
      handleClickNotificationButton,
      toggleNotificationFloatingMenu,
      handleClickNotificationList,
      handleClickNotificationMenu,
      toggleHelpFloatingMenu,
      handleClickHelpMenu,
      handleClickHelpCenter,
      toggleSettingFloatingMenu,
      handleClickSettingMenu,
      handleClickLogo,
      handleClickClip,
      isScoutAgent,
      agentSwitchText,
      changeMenuType
    };
  }
});
